const mutations = {
    PRODUCTS_LOADING: state => {
        state.productsStatus = "loading";
    },
    PRODUCT_VENUES: (state, venues) => {
        state.productsStatus = "success";
        Vue.set(state, "venues", venues.data);
    },
    PRODUCT_CATEGORIES: (state, categories) => {
        state.productsStatus = "success";
        Vue.set(state, "categories", categories.data);
    },
    PRODUCTS: (state, products) => {
        state.productsStatus = "success";
        Vue.set(state, "products", products.data);
    },
    PRODUCTS_ERROR: (state, err) => {
        let errors = err.error ? err.error : {};

        state.productsStatus = "error";
        state.productsErrors.record(errors);
    },
    SHOPPING_SUCCESS: state => {
        state.shoppingStatus = "success";
    },
    SHOPPING_LOADING: state => {
        state.shoppingStatus = "loading";
    },
    SHOPPING_ERROR: (state, err) => {
        let errors = err.error ? err.error : {};

        state.shoppingStatus = "error";
        state.shoppingErrors.record(errors);
    },
    ADD_TO_CART(state, product) {
        const found = state.shoppingCart.find(currentProduct => currentProduct.product_id == product.product_id);

        if (found) {
            found.product_quantity++;
            found.product_totalPrice = found.product_quantity * found.product_price;
        } else {
            state.shoppingCart.push({
                product_id: product.product_id,
                product_title: product.product_name,
                product_price: product.product_price,
                product_quantity: 1,
                product_akv: product.product_voucher_eligible,
                product_totalPrice: product.product_price,
                product_court: product.product_court,
                product_no_attendee: product.product_no_attendee,
                product_order_qty_max: product.product_order_qty_max,
                product_hpc: product.product_is_hpc,
            });

            state.shoppingCartCount++;
        }

        state.showCart = !state.showCart;
    },
    ADD_QTY_TO_CART(state, product) {
        const found = state.shoppingCart.find(currentProduct => currentProduct.product_id == product.product_id);

        if (found) {
            found.product_quantity++;
            found.product_totalPrice = found.product_quantity * found.product_price;
        }

        // state.showCart = !state.showCart;
    },
    REMOVE_QTY_TO_CART(state, product) {
        const found = state.shoppingCart.find(currentProduct => currentProduct.product_id == product.product_id);

        if (found) {
            found.product_quantity--;
            found.product_totalPrice = found.product_quantity * found.product_price;
        }

        if(found.product_quantity == 0){
            const index = state.shoppingCart.findIndex(currentProduct => currentProduct.product_id === product.product_id);
            state.shoppingCart.splice(index, 1);

            state.shoppingCartCount--;
        }

        // state.showCart = !state.showCart;
    },
    SHOW_CART_STATE(state, data) {
        state.showCart = data;
    },
    REMOVE_FROM_CART(state, removedProduct) {
        const index = state.shoppingCart.findIndex(currentProduct => currentProduct.product_id === removedProduct.product_id);
        state.shoppingCart.splice(index, 1);

        state.shoppingCartCount--;

        // state.products
        //     .find(product => product.product_id === removedProduct.product_id)
        //     .inventory += removedProduct.product_quantity;
    },
    STORE_CART: state => {
        window.localStorage.setItem("shoppingStoreCart", JSON.stringify(state.shoppingCart));
        window.localStorage.setItem("shoppingStoreCartCount", state.shoppingCartCount);
    },
    REMOVE_CART: state => {
        state.shoppingCart = [];
        state.shoppingCartCount = 0;
        Vue.set(state, "shoppingCart", []);
        Vue.set(state, "shoppingCartCount", 0);
        window.localStorage.removeItem("shoppingStoreCart");
        window.localStorage.removeItem("shoppingStoreCartCount");
    },
    CLEAR_PAYMENT_ERRORS: state => {
        state.paymentStatus = "";
        state.paymentErrors.clear();
    },
    PAYMENT_LOADING: state => {
        state.paymentStatus = "loading";
    },
    PAYMENT_SUCCESS: state => {
        state.paymentStatus = "success";
    },
    PAYMENT_ERROR: (state, err) => {
        let errors = err.error ? err.error : {};

        state.paymentStatus = "error";
        state.paymentErrors.record(errors);
    },
    RESET_STATE: state => {
        Object.assign(state, state.initialState());
    },
};

export default mutations;
